import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/site";
type CtaButtonProps = {
  label: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  id,
  className = ""
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group mx-auto flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#14532D,0_14px_30px_-8px_rgba(22,163,74,0.6)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-dark active:translate-y-[4px] active:shadow-[0_2px_0_0_#14532D] focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-gold sm:text-xl ${className}`} data-id="element-32" data-mp="hhj1sw3b3pxi">
      <span data-id="element-33" data-mp="198p4nkaew1qh">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-34" data-mp="159zv62shv4c4" />
    </a>;
}